export const MONTHLY_DROPDOWN_OPTIONS = [
  {
    value: 0,
    label: 'January'
  },
  {
    value: 1,
    label: 'February'
  },
  {
    value: 2,
    label: 'March'
  },
  {
    value: 3,
    label: 'April'
  },
  {
    value: 4,
    label: 'May'
  },
  {
    value: 5,
    label: 'June'
  },
  {
    value: 6,
    label: 'July'
  },
  {
    value: 7,
    label: 'August'
  },
  {
    value: 8,
    label: 'September'
  },
  {
    value: 9,
    label: 'October'
  },
  {
    value: 10,
    label: 'November'
  },
  {
    value: 11,
    label: 'December'
  }
];
export const DATE_RANGE_DROPDOWN_OPTIONS = [
  {
    label: 'seven_day',
    value: 7
  },
  {
    label: 'fifteen_day',
    value: 15
  },
  {
    label: 'thirty_day',
    value: 30
  },
  {
    label: 'three_month',
    value: 90
  },
  {
    label: 'six_month',
    value: 180
  },
  {
    label: 'past_year',
    value: 365
  }
];
export const DATE_RANGE_OPTIONS = [
  {
    label: 'this_month'
  },
  {
    label: 'this_quarter'
  },
  {
    label: 'this_year'
  },
  {
    label: 'last_month'
  },
  {
    label: 'last_quarter'
  },
  {
    label: 'last_year'
  }
];
export const CMS_IMAGE_DIMENSIONS = {
  article_content: {
    width: 388,
    height: 364
  },
  feature_block_main_image: {
    width: 1512,
    height: 1080
  },
  feature_block_side_image: {
    width: 748,
    height: 532
  },
  type_trend_image: {
    width: 510,
    height: 250
  },
  merchandising_image: {
    width: 510,
    height: 250
  }
};
// Unicode for numbers inside circles
export const NUMBER_CIRCLE_GLYPH = {
  1: '&#x2776;',
  2: '&#x2777;',
  3: '&#x2778;',
  4: '&#x2779;',
  5: '&#x277A;',
  6: '&#x277B;',
  7: '&#x277C;',
  8: '&#x277D;',
  9: '&#x277E;'
};

// Adobe CJA SDK URLs
export const MFP_ADOBE_CJA_SDK_PROD =
  'https://assets.adobedtm.com/843baba4f0fe/1cde091f5ab6/launch-ad03c9a9c39e.min.js';
export const MFP_ADOBE_CJA_SDK_PREPROD =
  'https://assets.adobedtm.com/843baba4f0fe/1cde091f5ab6/launch-275deb465ba3-staging.min.js';
export const MFP_ADOBE_CJA_SDK_DEV =
  'https://assets.adobedtm.com/843baba4f0fe/1cde091f5ab6/launch-06504f28eb13-development.min.js';

export const DATE_RANGE_DROPDOWN_DEFAULT_DAYS = 'last_year';
export const PROD_DOMAIN = 'https://fontplatform.monotype.com';
export const PROD_EKS_DOMAIN = 'https://fontplatform-eks.monotype.com';
export const PRE_PROD_DOMAIN = 'https://fontplatform-eks.monotype-pp.com';
export const PRE_PROD_DOMAIN_CERBERUS = 'https://fontplatform-eks-cerberus.monotype-dev.com';
export const PRE_PROD_DOMAIN_CERBERUS_2 = 'https://fontplatform-eks-cerberus2.monotype-dev.com';
export const PRE_PROD_DOMAIN_ALEXANDRIA = 'https://fontplatform-eks-alex.monotype-dev.com';
export const UAT_DOMAIN = 'https://fontplatform-eks-qa.monotype-pp.com';
export const LOCAL_DOMAIN = 'http://127.0.0.1';
export const CUSTOM_PACKAGE = 'customPackage';
export const FAMILY_PACKAGE = 'familyPackage';
export const SINGLE_STYLE = 'singleStyle';
export const JWT_METHOD_FOR_LOGIN = 'login';
export const JWT_METHOD_FOR_PAYMENT_CREATE = 'payment-create';
export const JWT_METHOD_FOR_PAYMENT_UPDATE = 'payment-update';
export const AGREEMENTS_PERMISSION = 'agreements';
export const APPLICATIONS_PERMISSION = 'applications';
export const FOUNDRY_PROFILE_PERMISSION = 'foundryProfile';
export const PAYMENTS_PERMISSION = 'payments';
export const PROMOTIONS_PERMISSION = 'promotions';
export const SALES_REPORT_PERMISSION = 'salesReport';
export const SUBMISSION_PERMISSION = 'submissions';
export const USER_PROFILE_PERMISSION = 'profile';
export const MONOTYPE_EMAIL_DOMAIN = 'monotype.com';
export const FILE_NAME = 'agreements.zip';
export const FOUNDRY_SUPPORT_URL =
  'https://foundrysupport.monotype.com/hc/en-us/articles/360028552632-Font-Marketing-Best-Practices';
export const NO_EARNING = '$--.--';
export const NO_ORDER = '----';
export const MAX_SIZE_INGESTION_FAMILYNAME = 70;
export const MAX_SIZE_INGESTION_FAMILYNAME_CUSTOM = 80;
export const MIN_SIZE_INGESTION_FAMILYNAME = 2;
export const MIN_ORDER_MID_LENGTH = 6;
export const EMPTY_REPORT_URL = 'https://foundrysupport.monotype.com/hc/categories/360001815972-Payments-Reports';
export const LENGTH_SEVEN = 7;
export const ALLOWED_KEYS = ['Backspace', 'ArrowLeft', 'ArrowRight', 'Delete', 'Tab', '.'];
export const FONTS_ALLOWED_EXTENSIONS = ['otf', 'ttf', 'ttfv', 'tt', 'OT_TTFV'];
export const FONT_FORMAT_PRIORITY_ORDER = ['OT CFF', 'OT TT', 'OT TTF', 'OT TTFV', 'TTF'];
export const FOLDER_NESTING_DEPTH = 2;
export const SIS_MAX_PRICE = 10000;
export const AG_GRID_ROW_HEIGHT = 42;
export const DEFAULT_CURRENCY = 'USD';
export const DEFAULT_LOCATION = 'US';
export const BINARY_STATUS = {
  new: 'new',
  updated: 'updated',
  old: ''
};
export const FAMILY_LOCKED_FOR_EDIT_ERROR_CODE = 423;
export const SUBMISSION_ALREADY_EXISTS_IN_INGESTION_ERROR_CODE = 409;
export const CDN_RESIZE_URL = 'cdn-cgi/image';
export const ALLOWED_FONT_FILE_FORMATS = {
  'OT TTFV': 'OT TTFV',
  'OT CFF': 'OT CFF',
  'OT TT': 'OT TT',
  TT: 'TT',
  'OT TTF': 'OT TTF'
};
export const INGESTION_TYPES = {
  custom: 'custom-fonts',
  nonCustom: 'non-custom-fonts'
};
export const DROPSHIP_TYPE_CONST = {
  flip_font: 'FlipFont', // used to match with api type
  flipFont: 'FlipFont' // used on UI
};
export const DROPSHIP_TYPE = 'flip_font';
export const FAMILY_BULK_EDIT_TYPES = {
  contract: 'contractNumber',
  designer: 'designer',
  price: 'price',
  tags: 'tags',
  autoSortStyles: 'autoSortStyles',
  bulkDisplayFamily: 'bulkDisplayFamily',
  bulkRefineStyles: 'bulkRefineStyles'
}
export const DROPSHIP_CSV_PAYLOAD_MAP = {
  name: {
    csvKey: 'flipfont name',
    key: 'name',
    default: ''
  },
  id: {
    csvKey: 'contract id',
    key: 'contractIds',
    default: []
  },
  externalSkuId: {
    csvKey: 'external sku id',
    key: 'externalSkuId',
    default: ''
  },
  notes: {
    csvKey: 'notes',
    key: 'notes',
    default: ''
  }
};

export const DROPSHIP_FIELD_LIMITS = {
  externalSkuId: 100,
  notes: 512
};
export const FONT_FORMAT_NAMES = ['TrueType', 'OpenType', 'PostScript', 'Web Font', 'Bitmap Font'];
export const IGNORED_FONT_FORMAT_NAMES = ['TrueType', 'OpenType'];
export const IGNORED_FONT_FORMAT_NAMES_POSTFIX = ['Feature', 'Features'];
export const FONT_FILE_EXTENSIONS = [
  'ttf',
  '.ttf',
  'otf',
  '.otf',
  'woff',
  '.woff',
  'woff2',
  '.woff2',
  'eot',
  '.eot',
  'svg',
  '.svg',
  'ot cff',
  '.ot cff',
  'ot tt',
  '.ot tt',
  'ot ttf',
  '.ot ttf',
  'ot ttfv',
  '.ot ttfv'
];
export const MIN_LENGTH_AI_ENABLED = 350;
export const MIN_LENGTH_FOR_SHORTEN_TEXT = 350;
export const AI_ACTION_MICRO_FEEDBACK_TIME = 4000;
export const DESCRIPTION_CHAR_LIMITS = {
  minCharLimit: 350,
  displayCharLimit: 3200,
  maxCharLimit: 64000,
  editorMaxLimit: null
};
export const VALIDATION_EVENT_TYPE = {
  CHANGE: 'change',
  BLUR: 'blur'
};

export const DATE_DEFAULT_FORMAT = 'YYYYMMDD';
export const DEFAULT_TIMEZONE_FORMAT = 'EST5EDT';

// Arrays for price detection patterns
export const WRITTEN_NUMBERS = ['one', 'two', 'three', 'four', 'five', 'six', 'seven', 'eight', 'nine', 'ten'];
export const CURRENCY_WORDS = [
  'dollar',
  'dollars',
  'euro',
  'euros',
  'pound',
  'pounds',
  'yen',
  'yuan',
  'franc',
  'francs',
  'rupee',
  'rupees',
  'ruble',
  'rubles',
  'won'
];
export const CURRENCY_CODES = ['USD', 'EUR', 'GBP', 'JPY', 'INR', 'RUB', 'KRW'];
export const PROMOTIONAL_PHRASES = [
  'just',
  'only',
  'get it for',
  'starts at',
  'from only',
  'as low as',
  'starting from',
  'beginning at'
];

export const REGEX_COLLECTIONS = {
  // less aggressive than SAFE_HTML_TAG_NAME_REGEX and SAFE_TAG_ATTR_REGEX combined, keeping it for future use-cases where we need to match HTML tags
  SAFE_HTML_TAG_REGEX: /<\/?[a-zA-Z][a-zA-Z0-9-]{0,19}\s*\/?>/,
  // Script symbol regex
  HTML_SYMBOLS_REGEX: /[<>]/,
  MOJIBAKE_REGEX: /[\u2500-\u257F\u00C0-\u00FF]/,
  // Emoji regex
  EMOJI_REGEX: /[\p{Emoji_Presentation}\p{Extended_Pictographic}]/u,
  // Script tag regex
  SCRIPT_TAG_REGEX: /&lt;\/?script.*?&gt;|<\/?script.*?>/i,
  // HTML tag regex
  SAFE_HTML_TAG_NAME_REGEX: /<\/?[a-zA-Z][\w-]{0,19}(\s+[a-zA-Z_:][\w:-]*)*\s*\/?>/,
  SAFE_TAG_ATTR_REGEX: /<\w+(?:\s+\w+=(?:"[^"]*"|'[^']*'))+\s*\/?>/,
  // Encoded tags
  SAFE_ENCODED_HTML_TAG_REGEX: /&lt;\/?[a-zA-Z][a-zA-Z0-9-]{0,19}\s*\/?&gt;/,
  SAFE_ENCODED_TAG_ATTR_REGEX: /&lt;[a-zA-Z][\w:-]{0,19}[^&]{0,100}=(?:"[^"]*"|'[^']*'|&#39;[^&#39;]*&#39;)[^&]*&gt;/,
  ENCODED_ANGLE_BRACKETS_REGEX: /(&(lt|#60);).*?(&(gt|#62);)/i,
  // AI Text Editor validation regex patterns
  // Price detection patterns
  PRICE_SYMBOL_BEFORE: /[$€£¥₹₽₩]\s*\d+(?:\.\d{2})?/g,
  PRICE_SYMBOL_AFTER: /\d+(?:\.\d{2})?\s*[$€£¥₹₽₩]/g,
  // Dynamic price patterns (created using the arrays above)
  PRICE_DIGIT_CURRENCY: new RegExp(
    `\\b\\d+\\s+(?:${[...CURRENCY_WORDS, ...CURRENCY_CODES].join('|')})\\b|\\b(?:${[
      ...CURRENCY_WORDS,
      ...CURRENCY_CODES
    ].join('|')})\\s+\\d+\\b`,
    'gi'
  ),
  PRICE_WRITTEN_CURRENCY: new RegExp(
    `\\b(?:${WRITTEN_NUMBERS.join('|')})\\s+(?:${[...CURRENCY_WORDS, ...CURRENCY_CODES].join('|')})\\b|\\b(?:${[
      ...CURRENCY_WORDS,
      ...CURRENCY_CODES
    ].join('|')})\\s+(?:${WRITTEN_NUMBERS.join('|')})\\b`,
    'gi'
  ),
  PRICE_PROMOTIONAL_NUMBER: new RegExp(
    `\\b(?:${PROMOTIONAL_PHRASES.join('|')})\\s+(?:\\d+|${WRITTEN_NUMBERS.join('|')})\\b`,
    'gi'
  ),
  PRICE_PROMOTIONAL_CURRENCY: new RegExp(
    `\\b(?:${PROMOTIONAL_PHRASES.join('|')})\\s+(?:\\d+|${WRITTEN_NUMBERS.join('|')})\\s+(?:${[
      ...CURRENCY_WORDS,
      ...CURRENCY_CODES
    ].join('|')})\\b`,
    'gi'
  ),
  EMAIL_PATTERN: /([a-z0-9._-]+@[a-z0-9._-]+\.[a-z0-9_-]+)/gi,
  PHONE_PATTERN: /\+?\d{1,4}[-.\s]?\d{2,5}([-.\s]?\d{2,5}){1,3}/g,
  URL_PATTERN: /(https?:\/\/)?(www\.)?[a-z0-9]+([-.][a-z0-9]+)*\.[a-z]{2,}([a-z0-9()@:%._~#?&/=+-]*)/gi,
  EXTRA_SPACES_PATTERN: / {2,}/g,
  EXTRA_SPACES_WITH_CONTEXT_PATTERN: /(\S+)( {2,})(\S+)/g,
  FORBIDDEN_URL_PATTERN: /myfonts\.com/i,
  FREE_FONT_PATTERN: /\b(free\s+font(s)?|font(s)?\s+(are|is)\s+free)\b/i,
  FONT_EXTENSION_PATTERN: `\\b(${FONT_FILE_EXTENSIONS.join('|')})\\b`,
  FONT_FORMAT_PATTERN: `\\b(${FONT_FORMAT_NAMES.join('|')})\\b`,
  HTML_TAG_PATTERN: /<\/?[\w\s="'/:;#.-]+>/gi,
  // match all the new lines
  NEW_LINE_REGEX: /(?:\r?\n)+/,
  SPACE_UNICODE: /&nbsp;/gi,
  SPACE_ESCAPED: /\u00A0/g,
  ALLOWED_CHARS_PATTERN_FOR_FAMILY_NAME: /^[\p{L}0-9\-_.& ]+$/u
};
export const INGESTION_STATUS = {
  draft: 'in_work'
};
export const DROPSHIP_STATUS = {
  inProgress: 'in_progress',
  error: 'error',
  success: 'success',
  draft: 'in_work'
};
/** SIS error popup */
export const ERROR_PAGES = ['400', '403', '404', '412', '424', '500', '503'];
export const SORTING_ORDER = ['asc', 'desc'];
export const SORTING_ORDER_DIRECTION = {
  asc: 'asc',
  desc: 'desc'
};
export const DOWNLOAD_FORMAT = {
  csv: 'csv',
  xls: 'xls',
  mimeType_csv: 'text/csv;charset=utf-8;',
  mimeType_xls: 'application/vnd.ms-excel'
};
export const ACTIONS = {
  edit: 'edit',
  delete: 'delete',
  note: 'note'
};
/** */

/** SIS upload zone */
export const MALWARE_STATUS = {
  scanning: 'scanning',
  success: 'success',
  failed: 'failed'
};
/** */

export const INGESTION_SELECTION_TYPE = {
  ingestion: 'ingestion',
  draft: 'draft'
};

export const DROPSHIP_SELECTION_TYPE = {
  dropShip: 'dropShip',
  draft: 'draft'
};

export const DROPSHIP_STATUS_CONST = ['Transferring', 'Error', 'Success'];

export const DROPSHIP_API_OBJECT_KEYS = {
  lastUpdated: 'updated_at',
  owner: 'owner_name',
  projectName: 'project_name'
};

export const DROPSHIP_UPLOADER_LIMITS = {
  maxSize: 5 * 1024 * 1024,
  allowedExtensions: ['.csv'],
  requiredHeader: 'flipfont name'
};

export const INGESTION_TYPE_CONST = ['Custom', 'Non-Custom'];
export const INGESTION_STATUS_CONST = ['Transferring', 'Error', 'Success'];

export const INGESTION_STATUS_DRAFT = ['Saved', 'Processing...', 'No font files'];

export const INGESTION_STATUS_STATE = {
  inProgress: 'in_progress',
  error: 'error',
  success: 'success'
};

export const INGESTION_STATUS_DRAFT_CONST = {
  saved: 'saved',
  processing: 'processing',
  noFontFiles: 'noFontFiles'
};

export const POST_SUBMISSION_STATUS = {
  success: 'Success',
  partial_success: 'partial success'
};

export const INGESTION_MODAL_VALIDATIONS = {
  existing_mid_error: '|existing_mid_error',
  required_only_numeric_mid: 'required|only_numeric_mid',
  only_numeric_mid: 'only_numeric_mid'
};

export const INGESTION_TAGS_LIMIT = 20;
export const INGESTION_TAG_CHAR_LIMIT = 30;

export const UNVERIFIED_USERS_PAGE_SIZE = 20;

export const UNVERIFIED_USERS_TABLE_HEADERS = ['email', 'accountStatus', 'lastLogin']; 

export const PRICE_INPUT_ALLOWED_KEYS = ['Backspace', 'ArrowLeft', 'ArrowRight', 'Delete', 'Tab', '.'];

export const CUSTOM_FOUNDRY_NAME = 'Custom';
// Binary polling constants
export const BINARY_POLLING_SINGLE_RETRY_ATTEMPTS = 1;
export const BINARY_POLLING_RETRY_ATTEMPTS = 3;

export const FAMILY_MAPPING_STATUS = {
  IDLE: 'idle',
  IN_PROGRESS: 'in_progress',
  SUCCESS: 'success',
  FAILED: 'failed'
};

export const FAMILY_DETAILS_KEYS = {
  familyName: 'family name',
  familyPrice: 'family price',
  family_price: 'familyPrice',
  displayFamilyName: 'displayFamilyName',
  publishDate: 'publishDate'
};

export const USER_MANUAL_URL =
  'https://monotype.atlassian.net/wiki/spaces/PPO/pages/6156026220/User+manual+Foundry+Platform+for+internal';
export const ERROR_TYPES = {
  error: 'ERROR',
  warning: 'WARNING'
};

export const DESCRIPTION_SIMILARITY_THRESHOLDS = {
  warning: 80,
  error: 95
};
export const AI_RESPONSE_ERROR_TYPES = {
  general: 'general',
  rateLimit: 'rateLimit'
};

export const AI_SUGGESTION_ASSET_TYPES = {
  foundry: 'foundry',
  bundle: 'bundle',
  submission: 'submission',
  designer: 'designer'
};

export const AI_TAGS_FEEDBACK = {
  action: 'aiTagsFeedback',
  suggestionType: 'tags',
  assetType: {
    submission: 'submission',
    inventorySubmission: 'inventorySubmission'
  },
  messageMaxLength: 3200
};

export const DESCRIPTION_TEXT_LIMIT = {
  submission: 500
};

export const FLIP_FONTS_LISTING = {
  fieldFlipFontFileName: 'flipFontFileName',
  fieldExternalSkuId: 'externalSkuId',
  fieldContractNumber: 'contractNumber',
  fieldActions: 'actions',
  sourceGrid: 'grid',
  sourceUpdateData: 'updateData',
  sourceInput: 'input',
  sourceSingle: 'single',
  csvFileSuffix: '_Files'
};

export const AG_GRID_HEADER_RENDERER = {
  sortNone: 'none'
};

export const AI_AGREEMENT_TYPE = 'foundryAiConsent';

// Toggle Switch Colors
export const TOGGLE_SWITCH_COLORS = {
  ON: '#1A73E8', // Primary blue color for switch ON state
  OFF: '#C3CAD4' // Light gray color for switch OFF state
};
 
// AI Text Editor Toggle Colors
export const AI_TOGGLE_COLORS = {
  ON: '#26a568', // Turtle green color for AI toggle ON state
  OFF: '#ccc' // Light gray color for AI toggle OFF state
};

export const CONFIRMATION_MODAL_PRIMARY_BUTTON_COLOR = {
  primary: 'red',
};

// Language analysis constants for AI text editor
export const LANGUAGE_ANALYSIS = {
  regex: {
    // Unicode script-based grouping for CJK
    cjkScripts: /\p{Script=Han}|\p{Script=Hiragana}|\p{Script=Katakana}|\p{Script=Hangul}/u,
    // Word separators to split latin words
    separator: /\s|[.,;!?()"'“”‘’]/,
    // Unicode letter detector
    letter: /\p{Letter}/u,
    // ASCII latin-only words a-z
    asciiLatin: /^[a-z]+$/
  },
  stopwords: {
    en: [
      'the', 'and', 'is', 'are', 'of', 'to', 'in', 'for', 'with', 'on', 'that', 'this', 'as', 'by', 'it', 'be', 'from', 'or', 'an', 'at', 'which', 'we', 'you', 'your', 'our'
    ],
    fr: [
      'le', 'la', 'les', 'un', 'une', 'des', 'et', 'est', 'sont', 'de', 'du', 'dans', 'pour', 'avec', 'sur', 'sous', 'entre', 'chez', 'sans', 'plus', 'pas', 'que', 'qui', 'quoi', 'dont', 'ou', 'ou', 'ce', 'cet', 'cette', 'cela', 'ca', 'au', 'aux', 'par', 'comme', 'mais', 'donc', 'or', 'ni', 'car', 'nous', 'vous', 'ils', 'elles', 'leur', 'leurs', 'mes', 'tes', 'ses', 'notre', 'votre', 'leurs', 'etre', 'avoir'
    ],
    de: [
      'der', 'die', 'das', 'ein', 'eine', 'einer', 'eines', 'einem', 'einen', 'und', 'ist', 'sind', 'sein', 'seine', 'seiner', 'seinen', 'haben', 'hat', 'habe', 'von', 'zu', 'mit', 'auf', 'für', 'fuer', 'im', 'am', 'an', 'beim', 'zum', 'zur', 'dem', 'den', 'des', 'nicht', 'wie', 'oder', 'aber', 'weil', 'wenn', 'dann', 'auch', 'doch', 'schon', 'mehr', 'weniger', 'sehr', 'hier', 'dort', 'dies', 'dieser', 'diese', 'dieses', 'jeder', 'jede', 'jedes', 'kein', 'keine', 'keinen', 'wir', 'ihr', 'sie', 'es', 'aus', 'nach', 'ueber', 'ueber'
    ],
    es: [
      'el', 'la', 'los', 'las', 'un', 'una', 'unos', 'unas', 'y', 'o', 'de', 'del', 'en', 'para', 'con', 'que', 'por', 'como', 'es', 'son', 'esta', 'este', 'estos', 'estas', 'nosotros', 'vosotros', 'ellos', 'ellas'
    ]
  },
  thresholds: {
    englishMinFraction: 0.8,
    dominanceMinCount: 3,
    nonEnglishStopMin: 5,
    nonEnglishStopDensityMin: 0.4
  }
};

export const SPLIT_FAMILY_ERROR_KEYS = {
  SUBMISSION_IS_LIVE: 'Cannot split family: submission is already live.',
  FAMILY_NAME_ALREADY_EXISTS: 'Family name already exists.'
};
export const EMAIL_VERIFY_BANNER_DISMISSED_STORAGE_KEY = 'fouEmailVerifyBannerDismissed';
export const RESEND_EMAIL_COOLDOWN_TIME = 60; // in seconds (1 minute)
export const HAS_EMAIL_SENT_ONCE_KEY = 'fouEmailSentOnce';